export const getPageSectionByName = (cmsSections, sectionName) => {
    if (!Array.isArray(cmsSections) || !cmsSections.length) {
        return null;
    }

    const section = cmsSections.find(
        item => item?.pageSection?.name === sectionName
    );

    return section?.pageSection || null;
};

